// @ts-nocheck
import { AsyncActionSuffix } from '../../../core/store/actionCreators';

const initialState = {
  pendingActions: [],
};

function getActionName(actionType) {
  if (typeof actionType !== 'string') {
    return null;
  }

  return actionType.split('/').slice(0, -1).join('/');
}

export default function pendingReducer(state = initialState, action) {
  const { type } = action;
  const actionName = getActionName(type);

  if (!actionName) {
    return {
      ...state,
    };
  }

  if (type.endsWith(`/${AsyncActionSuffix.Pending}`)) {
    return {
      ...state,
      pendingActions: state.pendingActions.concat(actionName),
    };
  }

  if (
    type.endsWith(`/${AsyncActionSuffix.Fulfilled}`) ||
    type.endsWith(`/${AsyncActionSuffix.Rejected}`)
  ) {
    return {
      ...state,
      pendingActions: state.pendingActions.filter(pendingAction => pendingAction !== actionName),
    };
  }

  return {
    ...state,
  };
}
